var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDubleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20C5.23578 20 0.75 15.5142 0.75 10C0.75 4.48578 5.23578 3.23382e-10 10.75 7.20902e-10C16.2642 1.11842e-09 20.75 4.48578 20.75 10C20.75 15.5142 16.2642 20 10.75 20Z",
    fill: "#3E64F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95 9.20004L11.55 9.20004L11.55 5.79996C11.55 5.35832 11.1916 5 10.75 5C10.3084 5 9.95004 5.35832 9.95004 5.79996L9.95004 9.20004L6.54996 9.20004C6.10832 9.20004 5.75 9.55836 5.75 10C5.75 10.4416 6.10832 10.8 6.54996 10.8L9.95004 10.8L9.95004 14.2C9.95004 14.6417 10.3084 15 10.75 15C11.1916 15 11.55 14.6417 11.55 14.2L11.55 10.8L14.95 10.8C15.3917 10.8 15.75 10.4416 15.75 10C15.75 9.55836 15.3917 9.20004 14.95 9.20004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.75 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubleIcon);
export default __webpack_public_path__ + "static/media/dubleIcon.1a6318579f5edf805f81ea2732ced0f0.svg";
export { ForwardRef as ReactComponent };